export default __webpack_public_path__ + "static/media/chillerCarrierXA.94098f7f.jpg";